import { Component, OnDestroy, OnInit, AfterViewInit, Inject, ViewChild, ElementRef, TemplateRef, SecurityContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap, NavigationExtras } from '@angular/router';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { VisualActions } from "../../models/const.Contants";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalService } from '../_infrastructure/Modal/ModalService';
import { combineLatest, Observable } from 'rxjs';
import { PreventInputDirective } from '../_infrastructure/PreventInputDirective';
import { LoadingMaskService } from '../_infrastructure/LoadingMask/LoadingMaskService';
import { DomSanitizer } from '@angular/platform-browser';
import { filter, map, tap } from 'rxjs/operators';
import { LogType } from '../../models/const.LogModelVM';
import { LogService } from '../_infrastructure/log/LogService';
import { CacheService } from '../_infrastructure/Cache/CacheService';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

import { NSIAuthService } from '../_infrastructure/NSIAuthService/NSIAuthService';

@Component({
    selector: 'workflow-search',
    templateUrl: './workflow-search.component.html',
    styleUrls: ['./workflow-search.component.scss'],
    standalone: false
})

export class WorkflowSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly VisualActions = VisualActions;
  public cards: models.WorkflowInformationVM[];
  public cardsAll: models.WorkflowInformationVM[];
  public filter: string;
  public workflowCode: string;
  public messageCode: string;
  public message: string;
  public domain: string;
  public oldForms: string;
  public oldForms11: string;
  public pdfFormUrl: string;

  //tipo User
  public isAtendimento: boolean;
  public atendimentoNumber: string;
  public atendimento: string;
  public tipoUtilizador: string;
  public isService: boolean;
  public serviceCode: string;
  public isUtilizador: boolean;
  public fileIdGuia: number;
  public fileIdFAQ: number;
  private counterToOldLiks: number = 0;

  public isNSI: boolean = false;
  public ShowContent: boolean = false;

  //PIT40803
  public destinoRouter: string;

  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef; 
  @ViewChild('cgaGetFileFormInput', { read: ElementRef }) cgaGetFileFormInput: ElementRef;

  @ViewChild('subscriberIntervention') subscriberIntervention: TemplateRef<any>;
  modalRef: BsModalRef;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private router: Router, private alertService: AlertService,
    @Inject(DOCUMENT) private document: Document, private systemInformationService: SystemInformationService, private loadingMaskService: LoadingMaskService,
    private securityService: SecurityService, private modalService: BsModalService, private modalS: ModalService, private sanitizer: DomSanitizer,
    private logService: LogService, private cacheService: CacheService, private translate: TranslateService, private sessionStorageService: SessionStorageService
    , private authServ: NSIAuthService  ) {
    this.activeRoute.paramMap.subscribe((params: ParamMap) => {
      this.workflowCode = params.get('code');

      if(!this.workflowCode) {
        this.loadWorkflowList();
      }
      this.loadSystemInfo();

      // PIT 40803 \\
      const options: models.OrigemAcessoInstanciaVM = {
        origemDoAcesso: '/workflowSearch',
      };
      this.sessionStorageService.setOrigemPedidoOnCache(options);
      // PIT 40803 \\
    });

    //const navigation = this.router.getCurrentNavigation();
    //const state = navigation.extras.state ;
    const state = history.state; 
    if (state) {
      this.messageCode = state.code;
      this.message = state.data;
    }


    this.atendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null);
    this.atendimentoNumber = this.securityService.userDetails.service;
    this.serviceCode = this.atendimento == "A" ? null : this.securityService.userDetails.service;

    this.tipoUtilizador = (this.atendimento == "A" ? "A" : ((!isNullOrUndefined(this.serviceCode)) ? "S" : "U"));
    this.isService = this.tipoUtilizador == "S" ? true : false;
    this.isUtilizador = this.tipoUtilizador == "U" ? true : false;

  }

  canCreatePrestage(workflowCode: string) {

    if (this.securityService.isUserServico()) {
      this.router.navigate(['/workflow-create', 'PEDI008B']);
      return;
    }

    this.loadingMaskService.setShowLoading(true, false);
    if (!this.securityService.userDetails?.utente) {
      let modal = <models.BaseModalVM>{
          isError: true,
          message: "WorkflowCreate.CannotFindSubscriber", param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check" 
          }
      };
      this.loadingMaskService.setShowLoading(false);
      this.modalS.showModals([modal]);
      return;
    }


    this.http.get<models.WorkflowStatusVM>('api/WorkflowSearch/CanCreatePreStageInstance',
      { params: { subscriberNumber: this.securityService.userDetails?.utente , workFlowCode: workflowCode } }).subscribe(result => {


        let data: any;
        data = { 'subscriberNumber': this.securityService.userDetails?.utente };

        if (result.stateCode == 'ER') {

          //entrada de subscritor para fase de pedido NPS (após prestage e revisao de serviço)
          if (result.exists) {
            let modal = <models.BaseModalVM>{
              isError: false, //result.stateCode == 'ER' ? true : false,
              message: "Já existe um pedido de ex-subscritor em curso. Pretende aceder ao pedido?", param: data,
              cancelButton: {
                hideButton: false,
                buttonText: 'Cancelar',
                buttonClass: 'btn-outline-primary',
                iconClass: "icon-close"
              },
              confirmButton: {
                hideButton: false,
                buttonText: "Continuar",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              },
            };
            this.loadingMaskService.setShowLoading(false);
            this.modalS.showModals([modal]).subscribe(res => {
              if (res) {
                this.router.navigate([`workflow/${result.workflowInstanceId.toString()}/step/StepSubscriberInfo`]);
              } 
              else {
                this.loadingMaskService.setShowLoading(false);
              }

            })

            return;
          }

          let modal = <models.BaseModalVM>{
            isError: true, //result.stateCode == 'ER' ? true : false,
            message: result.message,
            param: data,
            cancelButton: {
              hideButton: true,
              buttonText: "Ok",
              buttonClass: 'btn-primary',
              iconClass: "icon-check"
            }
          };
          this.loadingMaskService.setShowLoading(false);
          const modalRef = this.modalS.showModals([modal]);
          modalRef.subscribe(res => {
            window.scrollTo(0, 0);
          })
        }
        else {
          if (result.workflowInstanceId) {


            let modal = <models.BaseModalVM>{
              isError: false, //result.stateCode == 'ER' ? true : false,
              message: "Já existe um pedido de ex-subscritor em curso. Pretende aceder ao pedido?", param: data,
              cancelButton: {
                hideButton: false,
                buttonText: 'Cancelar',
                buttonClass:'btn-outline-primary',
                iconClass: "icon-close"
              },
              confirmButton: {
                hideButton: false,
                buttonText: "Continuar",
                buttonClass: 'btn-primary',
                iconClass: "icon-check"
              },
            };
            this.loadingMaskService.setShowLoading(false);
            this.modalS.showModals([modal]).subscribe(res => {
              if (res) this.router.navigate(['/workflow-create', workflowCode, result.workflowInstanceId, this.securityService.userDetails?.utente]);
              else {
                this.loadingMaskService.setShowLoading(false);
              }

            })
          }
          else {
            this.loadingMaskService.setShowLoading(false);
            this.router.navigate(['/workflow-create', workflowCode]);
          }
        }
      }, error => this.loadingMaskService.setShowLoading(false) )
  }


  //LIFECYCLE
  ngOnInit(): void {
    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\

    if (!this.modalS.hasShownSubscriberIntervention && !this.securityService.userDetails.informationGroups.includes("PGPA") && !this.securityService.userDetails.informationGroups.includes("PGPS")) {
      if (this.securityService.userDetails.utente) {
        let suffix = this.securityService.userDetails.utente.split(' ');
        if (suffix.length > 1 && suffix[1] != '00') return;
      }
      this.loadSubscriberInstances().subscribe(result => {
        var x = 1;
        if (result.instances.some(i => ((i.instanceStatus == "P" && ((i.instancePhase == "PCU" || i.instancePhase == "DS" || i.instancePhase == "PNS" && this.isUtilizador)))
                                    || (i.instanceStatus == "A" && i.instancePhase == "NPS" && this.isUtilizador)))) {
          let modal = <models.BaseModalVM>{
            isError: false,
            message: "WorkflowSearch.SubscriberIntervention"
          };

          this.modalS.hasShownSubscriberIntervention = true;

          this.modalS.showModals([modal]).subscribe(result => {
            if (result) this.navigateToInstanceBrowser();
          });
        }
      });
    }

    //this.http.post('api/WorkflowSearch/GetFileIdByCode',  { fileCode: 'GUIAFORM' } ).subscribe((data: any) => this.fileIdGuia = data);
    //this.http.post('api/WorkflowSearch/GetFileIdByCode', { fileCode: 'FAQFORM' } ).subscribe((data: any) => this.fileIdFAQ = data);    
  }

  private validateBrowser(url: string) {
    this.counterToOldLiks++;
    var bInvalidBrowser = 0;

    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edg') > -1:
        //'edge';
        bInvalidBrowser = 0;
        break;
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        //'opera';
        bInvalidBrowser = 1;
        break;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        //'chrome';
        bInvalidBrowser = 1;
        break;
      case agent.indexOf('trident') > -1:
        //'ie' - 'edge in IE mode' ;
        bInvalidBrowser = 0;
        break;
      case agent.indexOf('msie') > -1:
        //'ie';
        bInvalidBrowser = 0;
        break;
      case agent.indexOf('firefox') > -1:
        //'firefox';
        bInvalidBrowser = 1;
        break;
      case agent.indexOf('safari') > -1:
        //'safari';
        bInvalidBrowser = 1;
        break;
      default:
        //'other';
        bInvalidBrowser = 1;
        break;
    }

    if (bInvalidBrowser > 0) {
      /* Foi solicitado alterar a mensagem para popup
      this.alertService.clear();
      const message = this.translate.instant("Generic.InvalidBrowser");
      this.alertService.info(message);
      */

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "Generic.InvalidBrowser", param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary'
        }
      };
      this.modalS.showModals([modal]);

      return false;
    } else {
      this.openNewTab(url);
      //  const message: string = this.translate.instant("Generic.InvalidBrowserEdge");
      //  let modal = <models.BaseModalVM>{
      //    isError: false,
      //    message: message,
      //    cancelButton: {
      //      hideButton: false,
      //      buttonText: "Ver Instruções de Compatibilidade IE",
      //      buttonClass: 'btn-outline-primary'
      //    },
      //    confirmButton: {
      //      hideButton: false,
      //      buttonText: "Continuar",
      //      buttonClass: 'btn-primary'
      //    },
      //    isHtml: true
      //};
      //this.modalS.showModals([modal]).subscribe(res => {
      //  if (res===true) {
         
      //  } else {
      //    if (res === false) {
      //      this.getFormulario();
      //    }
      //  }
        
      //});

        return false;
      
      
    }

    return true;
  }


  private openNewTab(url: string): boolean {
  
    const newWindow = window.open(url, '_blank');

    if (newWindow) {
      newWindow.opener = null;
    }
    return true;
  }



  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    switch (this.messageCode) {
      case 'OK': {
        this.alertService.success(this.message);
        break;
      }
      case 'INFO': {
        this.alertService.info(this.message); break;
      }
      default: {
        this.alertService.error(this.message);
        break;
      }
    }
  }


//INTERNAL API CALLS
/**
* Loads list of workflows
*
* @remarks
* This is an api call
*
*/
  private loadWorkflowList() {

    const workflowsInformations$: Observable<models.WorkflowInformationVM[]> =
      this.http.get<models.WorkflowInformationVM[]>('api/WorkflowSearch/LoadWorkflowList', {});

    const workflowsHelpLinks$: Observable<models.WorkflowHelpLinkVM[]> =
      this.http.get<models.WorkflowHelpLinkVM[]>('api/WorkflowSearch/LoadWorkflowsHelpLinks', {});

    const result$ = combineLatest(workflowsInformations$, workflowsHelpLinks$)
      .pipe(
        filter(([workflowsInformations, workflowsHelpLinks]) => workflowsInformations !== null && workflowsHelpLinks !== null),
        map(([workflowsInformations, workflowsHelpLinks]) => {
          let result = workflowsInformations.map(wi => {
            if (!this.isNumeric(wi.workFlowHelpLink) && wi.workFlowHelpLink.length > 0) {
              const foundEntry = workflowsHelpLinks.find(wh => wh.codigo == wi.workFlowHelpLink);
              if (foundEntry !== null && foundEntry !== undefined) {
                wi.workFlowHelpLink = foundEntry.refFichId.toString();
              } else {
                const logModel: models.LogModelVM = {
                  message: `Could not found refFichId for workFlowHelpLink: ${wi.workFlowHelpLink}`,
                  type: LogType.Error
                };
                this.logService.logToBackend(logModel);
                this.cacheService.cacheMissingHelpLink(wi.workflowCode);
              }
            }
            return wi;
          });
          return result;
        })
      ).subscribe((newList: any) => {

        for (var index = 0; index < newList.length; index++) {
          if (newList[index].workflowFileVersionDate != "") {
            newList[index].workflowFileVersionDate = new Date(newList[index].workflowFileVersionDate).toISOString().split('T')[0]
          }
        }

        this.cards = this.cardsAll = newList;

      }, error => console.error(error))

      
  }

  /**
* Validate manifest intention
*
* @remarks
* This is an api call
*
*/
 

  private isNumeric(str: string): boolean {
    if (typeof str != "string") return false; // we only process strings!
    if (str === null || str === undefined) return false; // null or undefineds are not numbers
    if (str.length === 0) return false; // empty string are not numbers
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  } 
/**
* Validate manifest intention
*
* @remarks
* This is an api call
*
*/
  public loadSystemInfo() {
    this.systemInformationService.loadCurrentSystemInformation().subscribe(result => {
      this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
      //this.domain = result.cgaDirecta + result.fileTransfer;
      this.oldForms = this.securityService.userDetails.refererDomain + result.oldOnlineForms;
      this.oldForms11 = this.securityService.userDetails.refererDomain + result.oldOnlineForms.substr(0, result.oldOnlineForms.lastIndexOf("/")) + '/';
      this.pdfFormUrl = result.cgaDirecta + result.pdfTransfer;
      this.isNSI = result.proveniencia == "NSI";
      this.ShowContent = !this.isNSI;
      //NSI
      if (this.isNSI) {
        console.log("Proveniencia: " + result.proveniencia);
        const finalURl = this.authServ.getWorkflowNavigationUrl(result.workflowCode,
          result.instanceID,
          this.tipoUtilizador,
          this.securityService.isUserServico());
         
        
        if (finalURl != "") {
          this.router.navigateByUrl(finalURl);
        }
        else {
          this.canCreatePrestage(result.workflowCode);
        }

      }
      
    });
  }

  //COMPONENT RELATED METHODS
  public filterWorkList(event: KeyboardEvent) {
    if (event) {
      var searchVal = (event.target as HTMLInputElement).value.toUpperCase();
      this.cards = this.cardsAll.filter(x => x.workflowCode.toUpperCase().includes(searchVal) || x.title.toUpperCase().includes(searchVal));
    }else
      this.cards = this.cardsAll;
  }

  public getInstructions(workflowCode) {
    var fileCode = this.cardsAll.find(x => x.workflowCode.toUpperCase() == workflowCode).workFlowHelpLink;
    if (!this.cacheService.isMissingHelpLink(workflowCode)) {
      this.cgaGetFileFormInput.nativeElement.value = fileCode;
      this.cgaGetFileForm.nativeElement.action = this.domain;
      this.cgaGetFileForm.nativeElement.submit();
    } else {
      const message = this.translate.instant("BaseModal.HelpLinkNotFound");
      this.alertService.error(message);
    }
  }

  //public getFAQFormulario() {
  //  if (this.fileIdFAQ> 0) {
  //    this.cgaGetFileFormInput.nativeElement.value = this.fileIdFAQ;
  //    this.cgaGetFileForm.nativeElement.action = this.domain;
  //    this.cgaGetFileForm.nativeElement.submit();
  //  }
  //  else {
  //    const message = this.translate.instant("BaseModal.HelpLinkNotFound");
  //    this.alertService.error(message);
  //  }
  //}

  //public getGuiaFormulario() {
  //  if (this.fileIdGuia > 0) {
  //    this.cgaGetFileFormInput.nativeElement.value = this.fileIdGuia;
  //    this.cgaGetFileForm.nativeElement.action = this.domain;
  //    this.cgaGetFileForm.nativeElement.submit();
  //  }
  //  else {
  //    const message = this.translate.instant("BaseModal.HelpLinkNotFound");
  //    this.alertService.error(message);
  //    return false;
  //  }
  //}

  public navigateToInstanceBrowser() {
    // PIT 40803 \\
    this.sessionStorageService.removeListaDePedidosOption();
    // PIT 40803 \\
    this.router.navigate(['instancebrowser']);
  }

  public getPdf(workflowCode) {
      var link = this.cardsAll.find(x => x.workflowCode.toUpperCase() == workflowCode).workflowPrintLink;
      var url = this.sanitizeUrl(this.pdfFormUrl + link);
      if (this.validateUrl(link)) {
        window.open(url);
        return;
      }
      this.cgaGetFileFormInput.nativeElement.value = link;
      this.cgaGetFileForm.nativeElement.action = this.domain;

      this.cgaGetFileForm.nativeElement.submit();
  }

  private validateUrl(link) {
    return link.length > 4;
  }

  private sanitizeUrl(url):string {
    return  this.sanitizer.sanitize(SecurityContext.URL, url)
  }
  public loadSubscriberInstances(): Observable<models.InstanceBrowserVM> {
    let user = null;
    let params = {
      pageNumber: "0",
      pageSize: "0",
      ownerNumber: this.securityService.userDetails.utente,
      serviceCode: this.serviceCode,
      ownerType: this.tipoUtilizador
    };

    if (this.securityService.userDetails.utente == undefined || this.securityService.userDetails.utente == null) {
      user = this.securityService.userDetails.userName;
      params = {
        ...params, user: user
      } as any;
    }

    return this.http.get<models.InstanceBrowserVM>('api/InstanceBrowser/GetInstances',
      {
        params: params
      });
  }

  getUtenteTrimed(): string {
    var utente = this.securityService.userDetails.utente;
    return utente.split(' ')[0];
    const regex = / 00$/;
    utente = utente.replace(regex, '');
    return utente;
  }
}
